<template>
<div class="InteractionList">
    <div class="search_handle_box">
        <div style="width: 108px;">
            <el-select v-model="eventStatusValue" placeholder="全部状态">
                <el-option v-for="item in eventStatusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
        </div>
        <div style="width: 108px;">
            <el-select v-model="eventTypeValue" placeholder="全部类型">
                <el-option v-for="item in eventTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
        </div>
        <div style="width: 220px;">
            <el-input v-model="eventName" placeholder="请输入活动名称"></el-input>
        </div>
        <el-button @click="searchBtn" type="primary" plain>搜索</el-button>
    </div>
    <div class="table_box">
        <el-table :data="tableData" style="width: 100%">
            <el-table-column label="活动名称" width="320" align="center">
                <template slot-scope="scope">
                    <div class="event_info_box">
                        <img :src="scope.row.coveratturlid" alt="">
                        <div>
                            <p>{{scope.row.title}}</p>
                            <p>
                                <span>{{scope.row.jointypetext}}</span>
                            </p>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="活动时间" align="center" min-width="170">
                <template slot-scope="scope">
                    <p>{{scope.row.begintime}}</p>
                    <p>至</p>
                    <p>{{scope.row.endtime}}</p>
                </template>
            </el-table-column>
            <el-table-column prop="joincount" label="参与人数" align="center"></el-table-column>
            <el-table-column label="状态" align="center">
                <template slot-scope="scope"><span :class="statusTextClass(scope.row.statustext)">{{scope.row.statustext}}</span></template>
            </el-table-column>
            <el-table-column prop="datetime" label="创建时间" align="center" min-width="170"></el-table-column>
            <el-table-column label="操作" align="right" width="240">
                <template slot-scope="scope">
                    <div class="table_handle_box">
                        <span @click="toSubPage(scope.row, 'InteractionEventDetails')">活动详情</span>
                        <span> &nbsp;|&nbsp; </span>
                        <span @click="toSubPage(scope.row, 'InteractionRollList')">名单管理</span>
                        <span v-if="scope.row.status === 10 || scope.row.status === 0"> &nbsp;|&nbsp; </span>
                        <span @click="cancelActivity(scope.row)" v-if="scope.row.status === 10 || scope.row.status === 0">取消活动</span>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <div class="page_box">
            <el-pagination background layout="prev, pager, next" :total="total"  @current-change="fPage"></el-pagination>
        </div>
    </div>
</div>
</template>

<script>
import {getInteractEventinfoList, updateInteractEventinfoStatus} from 'api/operateToolApi'
import {mapActions} from 'vuex'
export default {
    name: 'InteractionList',
    data() {
        return {
            total: 100,
            eventName: '',
            eventTypeOptions: [
                {
                    value: '',
                    label: '全部方式'
                },
                {
                    value: '1',
                    label: '阅读型'
                },
                {
                    value: '2',
                    label: '互动型'
                }
            ],
            eventTypeValue: '',
            eventStatusOptions: [
                {
                    value: '',
                    label: '全部状态'
                },
                {
                    value: '0',
                    label: '未开始'
                },
                {
                    value: '10',
                    label: '进行中'
                },
                {
                    value: '30',
                    label: '已结束'
                },
                {
                    value: '100',
                    label: '已取消'
                }
            ],
            eventStatusValue: '',
            tableData: []
        }
    },
    mounted() {
        this.findInteractEventinfoList(1)
    },
    methods: {
        // 互动名单管理、活动详情路由跳转
        toSubPage(row, val) {
            this.$router.push({name: val, query: {eventinnerid: row.eventinnerid}})
        },
        // 取消活动
        cancelActivity(row) {
            this.$confirm('确认取消该活动？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                this.setLoading(true)
                var params = {
                    eventinnerid: row.eventinnerid,
                    status: 100
                }
                updateInteractEventinfoStatus({
                    data: Object.assign({}, params),
                    success: data => {
                        this.setLoading(false)
                        this.$message.success(`活动取消成功！`)
                        row.status = 100
                        row.statustext = '已取消'
                    },
                    error: data => {
                        console.log('error：', data)
                        this.$message.error(data.msg)
                        this.setLoading(false)
                    }
                })
            }).catch(() => {
                // 取消
            })
        },
        // 分页
        fPage(){
            let clickPage = $(".el-pagination .active").html()
            this.findInteractEventinfoList(clickPage)
        },
        // 搜索
        searchBtn() {
            this.findInteractEventinfoList(1)
        },
        // 查询互动活动列表
        findInteractEventinfoList(val) {
            this.setLoading(true)
            var params = {
                status: this.eventStatusValue,
                jointype: this.eventTypeValue,
                title: this.eventName,
                page: val,
                pageSize: 10
            }
            getInteractEventinfoList({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.tableData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        statusTextClass(val) {
            if(val === '未开始') {
                return 'yellow_text'
            } else if(val === '进行中') {
                return 'green_text'
            } else {
                return 'gray_text'
            }
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss">
.InteractionList {
    font-family:PingFangSC-Regular,PingFang SC;
    .search_handle_box {
        display: flex;
        justify-content: flex-end;
        .el-input__icon {
            line-height: 2px;
        }
        &>div {
            margin-right: 30px;
        }
    }
    .table_box {
        margin-top: 30px;
        .el-table th>.cell {
            font-weight: bold!important;
        }
        .el-table__empty-block {
            min-height: 360px;
        }
        .el-table__empty-text {
            box-sizing: border-box;
            line-height: 0px;
            padding-top: 150px;
        }
        .event_info_box {
            display: flex;
            img{
                width: 106px;
                min-width: 106px;
                height: 60px;
                margin-right: 10px;
            }
            &>div{
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                p{
                    text-align: left;
                    line-height: 18px;
                    text-overflow: -o-ellipsis-lastline;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    line-clamp: 2;
                    -webkit-box-orient: vertical;
                    span{
                        color: #F56C6C;
                        margin-right: 10px;
                    }
                    span:nth-last-of-type(1){
                        margin-right: 0;
                    }
                }
            }
        }
        .table_handle_box {
            span{
                color: #439FFE;
                cursor: pointer;
            }
        }
        .green_text {
            color: #67C23A;
        }
        .yellow_text {
            color: #E6A23C;
        }
        .gray_text {
            color: #606266;
        }
        .page_box {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 20px;
        }
    }
}
</style>